import React from 'react';
import NavigationPanel_QuickSearch from "../../../navigation/components/search/search";
import Navigation_MyAccountBtn from "../../../navigation/buttons/my-account";
import Navigation_ButtonUpgrade from "../../../navigation/buttons/upgrade";
import Navigation_ButtonHelp from "../../../navigation/buttons/help";
import NavigationLogo from "../../../navigation/components/logo/logo";
import Navigation_ButtonSpace from "../../../navigation/buttons/generic-space";
import {Position} from "../../../../core/gd/const/position";

export default function UI_TopPanel_Asana() {

    const showUpgrade   = !gd.company.license.isPaid

    const classes = Classes("ui-top-asana", {})

    const onClick = () => {
        gd.goTo('select-organization')
    };

    return (
        <div className={classes}>
            <div className="left">
                <div className="flex-row-left-center cursor-default" onClick={onClick}>
                    <NavigationLogo className="m-l-20"/>
                    <div className="ui5-color-txt-white fs-14 ui5-txt-bold-light" style={{marginLeft: 22, opacity: 0.8}}>
                        {gd.company.name}
                    </div>
                </div>
            </div>

            <div className="center">
                <NavigationPanel_QuickSearch/>
            </div>

            <div className="right flex-row-right-center m-r-10">
                {showUpgrade &&
                    <Navigation_ButtonUpgrade showLabel={false} className="m-r-15" />
                }

                <Navigation_ButtonSpace space={gd.spaces.aiChat} className="m-r-15" showLabel={false} hintPosition={Position.BOTTOM} />
                <Navigation_ButtonSpace space={gd.spaces.settings} className="m-r-15" showLabel={false} hintPosition={Position.BOTTOM} />
                <Navigation_ButtonSpace space={gd.spaces.help} className="m-r-15" showLabel={false} hintPosition={Position.BOTTOM}/>
                {/*<Navigation_ButtonHelp className="m-r-15"/>*/}
                <Navigation_MyAccountBtn className="m-0"/>
            </div>

        </div>
    );
}
